<template>
  <div class="d-flex align-start full-width">
    <EmojiPicker
      :bottom="true"
      :top="false"
      :class="{
        'mr-2 ml-n1': !!customRewardEmoji,
        'mr-6': !customRewardEmoji,
      }"
      class="pt-1"
      :placeholderEmoji="customRewardEmoji"
      @select="selectCustomEmoji"
    />
    <div class="d-flex ml-3 text-left full-width">
      <v-form
        ref="amountForm"
        v-model="customAmountForm"
        onSubmit="return false;"
        class="full-width"
      >
        <v-text-field
          outlined
          v-model="customRewardAmount"
          placeholder="0"
          :prefix="prefix"
          :suffix="suffix"
          color="brandPrimary"
          type="number"
          :rules="amountRules"
        ></v-text-field>
      </v-form>
      <Button
        v-if="showAddButton"
        color="brandPrimary"
        icon-left="mdi-plus"
        class="ml-4 mt-2"
        @click="selectCustomReward"
        :disabled="!customAmountForm || !customRewardAmount || !budgetId"
        >Add</Button
      >
    </div>
  </div>
</template>

<script>
import EmojiPicker from "@/components/EmojiPicker.vue";
import Button from "@/components/generic/Button.vue";
import { formRules } from "@/shared_data/data";

export default {
  name: "CustomRewardAmount",
  components: {
    EmojiPicker,
    Button,
  },
  props: {
    customEmoji: {
      type: String,
      default: null,
    },
    customAmount: {
      type: String,
      default: null,
    },
    showAddButton: {
      type: Boolean,
      default: true,
    },
    prefix: {
      type: String,
      default: null,
    },
    suffix: {
      type: String,
      default: null,
    },
    budgetId: {
      type: Number,
      default: null,
    },
    cashAward: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      customAmountForm: true,
      rules: formRules,
    };
  },
  computed: {
    amountRules() {
      if (!this.cashAward) {
        return this.rules.points(this.suffix ? this.suffix : "Points");
      }

      return this.rules.amount;
    },
    customRewardEmoji: {
      get: function () {
        return this.customEmoji;
      },
      set: function (newVal) {
        this.$emit("update-custom-emoji", newVal);
      },
    },
    customRewardAmount: {
      get: function () {
        return this.customAmount;
      },
      set: function (newVal) {
        this.$emit("update-custom-amount", newVal);
      },
    },
  },
  watch: {
    customAmountForm(newVal) {
      this.$emit("update-valid-amount", newVal);
    },
    budgetId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit("update-custom-amount", null);
        this.$nextTick(() => {
          this.customAmountForm = true;
          if (this.$refs.amountForm && this.$refs.amountForm.resetValidation) {
            this.$refs.amountForm.resetValidation();
          }
          this.$emit("update-valid-amount", true);
        });
      }
    },
  },
  methods: {
    selectCustomEmoji(emoji) {
      this.customRewardEmoji = emoji;
    },
    selectCustomReward() {
      this.$emit("select-custom-reward");
    },
  },
};
</script>

<style scoped></style>
